import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_MatrixChainMultiplication = () => (
  <DAAModuleSubtopic
    title="Dynamic Programming – Matrix Chain Multiplication"
    videos={[
      "https://www.youtube.com/embed/prx1psByp7U",
      "https://www.youtube.com/embed/eKkXU3uu2zk",
      "https://www.youtube.com/embed/_WncuhSJZyA",
      "https://www.youtube.com/embed/L_t8ROy0pjA?list=PL8xmnXn7pVtxhgdXyhT9s92hob4uY84dV"
    ]}
    takeaways={[
      { text: "The goal is to determine the most efficient way to multiply a chain of matrices by minimizing the number of scalar multiplications." },
      { text: "Matrix multiplication is associative, so the order of multiplication affects computation time but not the result." },
      { text: "Use a 2D DP table dp[i][j] where dp[i][j] stores the minimum number of multiplications for matrices i through j." },
      { text: "Time complexity: O(n³), Space complexity: O(n²), where n is the number of matrices." },
      
    ]}
    questions={[
      {
        text: "Consider a chain of 5 matrices with specific dimensions. Apply dynamic programming to find the minimum number of scalar multiplications needed for (A1.A2.A3.A4.A5) along with the optimal parenthesization.",
        image: "/MCM1.png"
      },
      {
        text: "Given a sequence of matrices <8,5,10,20,5>. Use dynamic programming to compute the minimum scalar multiplications and write the optimal parenthesization."
      },
      {
        text: "Provide the optimal parenthesization for multiplying matrices A1, A2, A3, A4, A5 with specified dimensions.",
        image: "/MCM2.png"
      },
      {
        text: "Outline important factors of Dynamic Programming and compute Matrix Chain Multiplication for the array {4, 10, 3, 12, 20, 7}. Compute dp[i][j] where 0 ≤ i, j ≤ 5 with base case dp[i][i] = 0."
      },
      {
        text: "Given matrix dimensions: A1: 5x4; A2: 4x3; A3: 3x5; A4: 5x2; A5: 2x4, fully parenthesize A1.A2.A3.A4.A5 to minimize scalar multiplications."
      }
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/Y-sr5Rk6T5A",
      "https://www.youtube.com/embed/LGrwhPoTpyk",
      "https://www.youtube.com/embed/OnuQ_7I6Ik0",
      "https://www.youtube.com/embed/bbeFPu67gG0"
    ]}
  />
);

export default DAA_MatrixChainMultiplication ;
